import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import "moment/locale/ja";
import en from "./locales/en/translation.json";
import jp from "./locales/jp/translation.json";

const resources = { en: { translation: en }, jp: { translation: jp } };

// Customer asked for "4か月前" specifically; moment's built-in ja locale
// otherwise renders that as "4ヶ月前".
moment.updateLocale("ja", {
  relativeTime: {
    MM: "%dか月",
  },
});

const applyMomentLocale = (lng) => {
  moment.locale(lng === "jp" ? "ja" : "en");
};

i18n
  .use(LanguageDetector) // detect user language automatically
  .use(initReactI18next) // connect i18n with React
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // React already escapes
    }
  })
  .then(() => applyMomentLocale(i18n.language));

i18n.on("languageChanged", applyMomentLocale);

export default i18n;
